import r from '../utils/request'

// Cookbook merchandising: what to show, dismissing, clicks, book progress, "Add to cookbook"

export const getPromos = () => r.get('/promos')

export const dismissPromo = (placement) => r.post(`/promos/${placement}/dismiss`)

export const clickPromo = (placement) => r.post(`/promos/${placement}/click`).catch(() => null)

// recipeId: a just-saved recipe, so the progress is for the family it was saved to
export const getBookProgress = (groupId, recipeId) =>
  r.get('/cookbooks-progress', {
    ...(groupId ? { group_id: groupId } : {}),
    ...(recipeId ? { recipe_id: recipeId } : {}),
  })

export const addRecipeToCookbook = (recipeId, groupId) =>
  r.post('/cookbooks-add-recipe', { recipe_id: recipeId, group_id: groupId || null })
